/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react'
import { useRouter } from 'next/router'
import { useQuery } from 'react-query'

import { usePenNameAction } from '@hooks/penName/usePenNameAction'
import {
  WithPenNameSearchSelectProps,
  PenNameSearchSelectProps,
} from './interface'

export function withPenNameSearchSelect(
  Component: React.FC<PenNameSearchSelectProps>
) {
  function WithPenNameSearchSelect({
    userId,
    onSearch,
  }: WithPenNameSearchSelectProps) {
    const penNameClient = usePenNameAction()
    const [searchText, setSearchText] = useState<string>('')
    const { query } = useRouter()

    const { data: penNameOptions = [] } = useQuery(
      ['pen-name-options-by-user', userId],
      () => penNameClient.getUserProfilePenNameOptions(userId),
      { enabled: !!userId }
    )

    const penNameSearchList = useMemo(() => {
      if (searchText) {
        return penNameOptions.filter(item =>
          item.label.toLowerCase().includes(searchText.toLowerCase().trim())
        )
      }
      return penNameOptions
    }, [searchText, penNameOptions])

    function handleSearchChange(value: string) {
      setSearchText(value)
    }

    function handleSelectChange(value: string) {
      setSearchText(value)
      onSearch(value)
    }

    useEffect(() => {
      setSearchText(query?.text?.toString() || '')
      onSearch(query?.text?.toString() || '')
    }, [])

    const componentProps = {
      searchText,
      penNameSearchList,
      onSearch,
      handleSearchChange,
      handleSelectChange,
    }
    return <Component {...componentProps} />
  }
  return WithPenNameSearchSelect
}
